import { Card, Flex, Grid, Text } from '@servicetitan/anvil2';
import { DataItem, formatCurrency } from '@servicetitan/financing-utils-shared';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { DecisionDataStore } from '../stores/DecisionDataStore';

export interface LoanDetailsProps {
    hideDetails?: boolean;
}

export const LoanDetails = ({ hideDetails = false }: LoanDetailsProps) => {
    const { decisionData } = DecisionDataStore.useStore();
    const { termMultiplier } = useProviderConfig();

    const { externalLoanId, approvedAmount, term, rate, payment, description } = decisionData ?? {};
    const date = new Date().toLocaleDateString();

    return (
        <Card flexDirection="column" style={{ maxWidth: '845px', width: '100%' }}>
            <Flex gap="3" direction="column">
                <Text variant="headline" el="h2" size="small">
                    Loan Details
                </Text>
                <Grid rowGap="4" templateColumns="repeat(auto-fit, minmax(255px, 1fr))">
                    <DataItem label="Application ID" text={externalLoanId} />
                    <DataItem label="Date" text={date} />
                    {!hideDetails && (
                        <>
                            <DataItem
                                label="Loan Amount"
                                text={formatCurrency(approvedAmount ?? 0)}
                            />
                            <DataItem
                                label="Term"
                                text={
                                    term ? [term * termMultiplier, 'months'].join(' ') : undefined
                                }
                            />
                            <DataItem label="Max APR" text={rate?.toFixed(2) + '%'} />
                            <DataItem label="Monthly Payment" text={formatCurrency(payment ?? 0)} />
                            <DataItem label="Plan Description" text={description} />
                        </>
                    )}
                </Grid>
            </Flex>
        </Card>
    );
};
